import {post} from '@/utils/request';
import {smcanteenserver} from '@/utils/baseUrl';
// import{sse_url} from '@/utils/baseUrl';

//订单列表
export async function getList(params) {
    return post(smcanteenserver+'/order/getList', params, true)
}

//食堂下拉
export async function getCanteenList(params) {
    return post(smcanteenserver+'/canteen/getCanteenList', params, true)
}

// //食堂删除
// export async function remove(params) {
//     return post(smcanteenserver+'/canteen/delete', params, true)
// }
//
// //菜品详情
// export async function getDetail(params) {
//     return post(smcanteenserver+'/canteen/getDetail', params, true)
// }

